// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2e5bu","row":"Node_row__3qRaK","label":"Node_label__17aMY","footer":"Node_footer__1qm6L"};